const twodigitmonth = (month) => {
    return month < 10 ? `0${month}` : month;
    }
    export default twodigitmonth;